import { useState } from 'react';
import classNames from 'classnames';
import { PRICES } from '../model/prices';
import styles from './styles.module.scss';

export const PriceSelector = ({ setValue }) => {
  const [selectedPrice, setPrice] = useState(null);

  const handleSelect = (value) => {
    setValue('price', value);
    setPrice(value);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <h4 className={styles['prices-title']}>Your budget (USD)</h4>

      <div className={styles['price-list']}>
        {Object.keys(PRICES).map((key) => (
          <div
            key={key}
            className={classNames(styles.price, { [styles.checked]: selectedPrice === PRICES[key] })}
            onClick={() => handleSelect(PRICES[key])}
          >
            {PRICES[key]}
          </div>
        ))}
      </div>
    </div>
  );
};
